var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "38px",
    viewBox: "0 0 39 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0A43EEFF-4F16-4F97-ADDA-68A7DBAD3A71") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mis-Datos-perfil-reputacion",
    transform: "translate(-663.000000, -409.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(664.500000, 411.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9196267,10.8651959 L37.1465471,12.8134165 L27.5760338,22.2069776 L29.8358604,35.4845176 L18,29.2121602 L6.16413963,35.4845176 L8.42396618,22.2069776 L-1.1465471,12.8134165 L12.0803733,10.8651959 L18,-1.21979294 L23.9196267,10.8651959 Z",
    id: "Shape-Copy-2",
    stroke: "#FFFFFF",
    strokeWidth: 1.07316,
    fill: "#F9CC54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2be89f970b3520583493fefa8a1b90cf.svg";
export { ForwardRef as ReactComponent };